export default {
  GET: 'getting',
  GETALL: 'listing',
  DELETE: 'deleting',
  CREATE: 'creating',
  UPDATE: 'updating',
};
